import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Badge,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
} from "reactstrap";
import HeaderDropdown from "./HeaderDropdown";
import { showSearchBar } from "../../actions/HeaderActions";
import { searchText } from "../../actions/SearchActions";
import { console_log } from "../../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { changeLangAction } from "../../actions/WelcomeActions";
import BottomLangDropDown from "../BottomLangDropDown/BottomLangDropDown";
import { MultiLangDomains } from "../../constants/multiLanguageSupport";
import * as multiDomains from "../../constants/multiDomains";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openLangMenu: false,
    };

    this.goBack = this.goBack.bind(this);
    this.searchOpen = this.searchOpen.bind(this);
    this.sidebarToggle = this.sidebarToggle.bind(this);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.onChange = this.onChange.bind(this);
    this.clearText = this.clearText.bind(this);
    this.handleChangeLang = this.handleChangeLang.bind(this);
    this.closeLangMenu = this.closeLangMenu.bind(this);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  goBack(e) {
    e.preventDefault();
    window.history.back();
  }

  searchOpen() {
    if (window.innerWidth <= 575) {
      this.clearText();
      window.history.back();
    } else {
      this.props.showSearchBar(!this.props.header.showSearchBar);
      let searchInput = document.querySelector("#search");
      if (!this.props.header.showSearchBar) {
        searchInput.focus();
      } else {
        searchInput.blur();
      }
      this.clearText();
    }
  }
  clearText() {
    this.props.searchText("");
  }

  onChange(e) {
    this.props.searchText(e.target.value);
  }

  changeSearchIcon() {
    let url = window.location.hash;

    if (url == "#/play/channel" || url == "#/play/video") {
      return <img src="./img/search-icon-white.svg" className="search-icon" />;
    } else {
      return (
        <img
          src="./img/search-icon.svg"
          className="search-icon"
          style={
            config.dir == "rtl" ? { position: "absolute", left: "-12px" } : {}
          }
        />
      );
    }
  }

  handleChangeLang(lang) {
    this.props.changeLang(lang);
    this.props.changeLangAction({
      currentLang: event,
    });
  }

  changeCancelIcon() {
    let url = window.location.hash;

    if (url == "#/play/channel" || url == "#/play/video") {
      return <img src="./img/close-white.svg" className="search__clear" />;
    } else {
      return <img src="./img/close.svg" className="search__clear" />;
    }
  }
  toggleLangMenu() {
    this.setState({
      openLangMenu: !this.state.openLangMenu,
    });
  }
  closeLangMenu() {
    this.setState({
      openLangMenu: false,
    });
  }
  render() {
    const isAdmin = this.props.isAdmin;
    let showSearch = this.props.showSearch;
    let showMenu = this.props.showMenu;
    let url = window.location.hash;
    const searchPlaceholder = {
      en: "Search...",
      no: "Søk...",
      fr: "Recherche...",
      pt: "Buscar...",
      ar: "ابحث",
      de: "Suchen...",
      cy: "Тражи",
      ee: "Otsing",
      es: "Buscar...",
      it: "Cerca...",
      el: "Αναζήτηση",
      id: "Mencari...",
    };

    return (
      <header className="app-header navbar">
        <div className="inner-header">
          <div className="container-fluid">
            <div className="nav-row">
              {!this.props.location.pathname.includes("/search") && (
                <div className="nav-col">
                  <div
                    className={
                      config.dir == "rtl"
                        ? config.lang === "ar"
                          ? "navbar-right"
                          : "navbar-left navbar-left-ar"
                        : "navbar-left"
                    }
                  >
                    {showMenu ? (
                      window.innerWidth <= 575 ? (
                        ""
                      ) : (
                        <NavbarToggler
                          className="d-lg-none"
                          onClick={this.mobileSidebarToggle}
                        >
                          <span className="icon-bar"></span>
                          <span className="icon-bar"></span>
                          <span className="icon-bar"></span>
                        </NavbarToggler>
                      )
                    ) : (
                      <Link
                        to={
                          url.indexOf("panoramic-show") >= 0
                            ? `/panoramic/?uid=${this.props.access.uid}`
                            : `/category/vod/?uid=${this.props.access.uid}`
                        }
                      >
                        <NavbarToggler
                          className="d-lg-none back-button"
                          style={
                            config.lang === "ar"
                              ? { right: 20 + "px", left: "unset" }
                              : {}
                          }
                        >
                          <span>
                            <i className="icon-arrow-left menu-icon"></i>
                          </span>
                        </NavbarToggler>
                      </Link>
                    )}
                    {showMenu ? (
                      <NavbarToggler
                        className="d-md-down-none"
                        style={{ marginLeft: "10px" }}
                        onClick={this.sidebarToggle}
                      >
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                      </NavbarToggler>
                    ) : (
                      <Link
                        to={
                          url.indexOf("panoramic-show") >= 0
                            ? `/panoramic/?uid=${this.props.access.uid}`
                            : `/category/vod/?uid=${this.props.access.uid}`
                        }
                      >
                        <NavbarToggler className="d-md-down-none back-button">
                          <span>
                            <i className="icon-arrow-left menu-icon"></i>
                          </span>
                        </NavbarToggler>
                      </Link>
                    )}
                    {this.props.header.title != "" &&
                    this.props.header.title != "VR Videos" ? (
                      <NavbarBrand className="page-title">
                        <span>{this.props.header.title}</span>
                      </NavbarBrand>
                    ) : (
                      <NavbarBrand
                        href={
                          config.domain === "plus"
                            ? `https://mobioplus.online/${
                                this.props.access.uid
                                  ? `?uid=${this.props.access.uid}`
                                  : ""
                              }`
                            : "/#/category/vod"
                        }
                        className={config.dir == "rtl" ? "navbar-brand-ar" : ""}
                      >
                        <img
                          className={
                            config.dir == "rtl"
                              ? config.lang === "ar"
                                ? "logo-image-right-ar logo-image"
                                : "logo-image-left-ar logo-image"
                              : "logo-image"
                          }
                          src={multiDomains.getLogo()}
                          alt="Mobio360"
                          style={
                            config.lang === "ar" ? { marginRight: "15px" } : {}
                          }
                        />
                      </NavbarBrand>
                    )}
                    {config.dir == "rtl" &&
                    window.innerWidth <= 575 &&
                    ![
                      "/search",
                      "/history",
                      "/account",
                      "/panoramic",
                      "/privacy-policy",
                    ].includes(this.props.location.pathname) ? (
                      <div>
                        <span
                          className="lang"
                          onClick={() => this.handleChangeLang("ar")}
                        >
                          AR
                        </span>
                        <span
                          className="lang"
                          onClick={() => this.handleChangeLang("en")}
                        >
                          EN
                        </span>
                      </div>
                    ) : null}
                    {["be", "ch"].indexOf(config.domain) >= 0 &&
                    window.innerWidth <= 575 &&
                    ![
                      "/search",
                      "/history",
                      "/account",
                      "/panoramic",
                      "/privacy-policy",
                    ].includes(this.props.location.pathname) ? (
                      <button
                        className="lang-button"
                        onClick={() => this.toggleLangMenu()}
                      >
                        {config.lang === "be" ? "nl" : config.lang}
                        <i className="fa fa-language"></i>
                      </button>
                    ) : null}
                  </div>
                </div>
              )}

              {showSearch ? (
                <div className="nav-col">
                  <Nav className="navbar search-wrap">
                    {isAdmin ? (
                      <HeaderDropdown logout={this.props.logout} />
                    ) : (
                      <NavItem className="search">
                        <NavLink href="javascript:void(0);"></NavLink>
                        <div
                          id="search-box"
                          className={
                            this.props.header.showSearchBar
                              ? "search-box search-box-toggle"
                              : "search-box"
                          }
                        >
                          <InputGroup
                            style={{
                              marginTop: 10 + "px",
                              marginRight: 10 + "px",
                            }}
                          >
                            <Input
                              className="search__input"
                              placeholder={
                                searchPlaceholder[config.lang]
                                  ? searchPlaceholder[config.lang]
                                  : searchPlaceholder.en
                              }
                              type="search"
                              name="search"
                              id="search"
                              maxLength="50"
                              value={this.props.search.searchText}
                              onChange={this.onChange}
                            />
                            <div className="input-group-addon search__addon">
                              <Button
                                className="search__btn"
                                onClick={
                                  !this.props.header.showSearchBar
                                    ? this.searchOpen
                                    : () => {}
                                }
                              >
                                {this.changeSearchIcon()}
                              </Button>
                            </div>
                            <button
                              className="search__addon--clear"
                              onClick={this.clearText}
                            >
                              {this.changeCancelIcon()}
                            </button>
                            <button
                              className="search__addon--cancel"
                              onClick={this.searchOpen}
                            >
                              <FormattedMessage
                                id="cancel"
                                defaultMessage="Cancel"
                              />
                            </button>
                          </InputGroup>
                        </div>
                      </NavItem>
                    )}
                  </Nav>
                </div>
              ) : (
                ""
              )}
              {this.state.openLangMenu ? (
                <BottomLangDropDown
                  changeLang={this.props.changeLang}
                  onClose={this.closeLangMenu}
                  languageData={MultiLangDomains[config.domain]}
                />
              ) : null}
            </div>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    header: state.HeaderReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    search: state.SearchReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      searchText,
      showSearchBar,
      changeLangAction,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js